import { useContext, useEffect, useState } from "react";
import { useFieldArray, useForm, Controller } from "react-hook-form";
import MultiSelect from "multiselect-react-dropdown";
import { ToastContainer, toast } from "react-toastify";

import {
  addProfessionValidation,
  errorResponseMessage,
} from "../shared/const.prop";
import { UserProfileContext } from "../contexts/UserProfileStepsContext";
import { AppContext } from "../contexts/AppContext";
import axiosHttp from "../config/axios.interceptor";
import { AuthContext } from "../contexts/AuthContext";

const AddProfessionInfo = () => {
  const userContext = useContext(UserProfileContext);
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const [interest, setInterest] = useState([]);
  const [expertises, setExpertises] = useState([]);
  const [skills, setSkills] = useState([]);
  const [skillValue, setSkillValue] = useState("");
  const [interestValue, setInterestValue] = useState("");
  const [expertiseValue, setExpertiseValue] = useState("");
  const [isOffered, setIsOffered] = useState(false);
  const [categories, setCategories] = useState([]);
  const {
    register,
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      companyDetails: [{ companyName: "", position: "", workExperience: "" }],
      interest: "",
      skills: "",
      offerService: false,
      experties: "",
      skillsCategory: [],
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "companyDetails",
  });
  const submitHandler = (data) => {
    userContext.updateUserInfo("updateUserInfo", data, "profession");
    console.log("data", data);
  };

  const offerService = watch("offerService", false);

  const handleOfferServiceChange = () => {
    const newValue = !offerService;
    setValue("offerService", newValue);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    if (!offerService) {
      setValue("experties", "");
    }
  }, [offerService]);

  useEffect(() => {
    if (skillValue !== "") {
      const getData = setTimeout(fetchSkillsList, 500);
      return () => clearTimeout(getData);
    }
  }, [skillValue]);

  useEffect(() => {
    if (interestValue !== "") {
      const getData = setTimeout(fetchInterestList, 500);
      return () => clearTimeout(getData);
    }
  }, [interestValue]);

  useEffect(() => {
    if (expertiseValue !== "") {
      const getData = setTimeout(fetchExpertisesList, 500);
      return () => clearTimeout(getData);
    }
  }, [expertiseValue]);

  const fetchCategories = async () => {
    try {
      const getCategoriesList = await axiosHttp.get(`skills-category`);
      setCategories(getCategoriesList.data);
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setCategories([]);
    }
  };

  const fetchSkillsList = async () => {
    try {
      const getSkillsList = await axiosHttp.get(
        `skills-new?skill=${skillValue}`
      );
      setSkills(getSkillsList.data.data);
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setSkills([]);
    }
  };

  const fetchInterestList = async () => {
    try {
      const getSkillsList = await axiosHttp.get(
        `skills-new?skill=${interestValue}`
      );
      setInterest(getSkillsList.data.data);
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setSkills([]);
    }
  };

  const fetchExpertisesList = async () => {
    try {
      const getSkillsList = await axiosHttp.get(
        `skills-new?skill=${expertiseValue}`
      );
      setExpertises(getSkillsList.data.data);
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setSkills([]);
    }
  };

  const handleChange = (selectedOptions, onChange) => {
    const ids = selectedOptions.map((option) => option._id);
    onChange(ids);
  };

  return (
    <>
      <form onSubmit={handleSubmit(submitHandler)}>
        {/* <div className="form-wrapper"> */}
        {fields.map((item, index) => {
          return (
            <div key={item.id} className="form-content">
              <div className="row mt-5">
                <div className="col-md-2"></div>
                <div className="col-md-4">
                  <div className="form-group input-group">
                    <div className="form-group input-group">
                      <span className="input-group-addon addon-icon py-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            d="M3.0625 1.75V11.375H10.9375V1.75H3.0625ZM2.625 0.875H11.375C11.491 0.875 11.6023 0.921094 11.6844 1.00314C11.7664 1.08519 11.8125 1.19647 11.8125 1.3125V11.8125C11.8125 11.9285 11.7664 12.0398 11.6844 12.1219C11.6023 12.2039 11.491 12.25 11.375 12.25H2.625C2.50897 12.25 2.39769 12.2039 2.31564 12.1219C2.23359 12.0398 2.1875 11.9285 2.1875 11.8125V1.3125C2.1875 1.19647 2.23359 1.08519 2.31564 1.00314C2.39769 0.921094 2.50897 0.875 2.625 0.875Z"
                            fill="#000842"
                          />
                          <path
                            d="M0.875 11.375H13.125V12.25H0.875V11.375ZM4.375 2.625H6.125V3.9375H4.375V2.625Z"
                            fill="#000842"
                          />
                          <path
                            d="M5.25 11.375H8.75V10.5C8.75 10.0359 8.56563 9.59075 8.23744 9.26256C7.90925 8.93437 7.46413 8.75 7 8.75C6.53587 8.75 6.09075 8.93437 5.76256 9.26256C5.43437 9.59075 5.25 10.0359 5.25 10.5V11.375ZM7 7.875C7.69619 7.875 8.36387 8.15156 8.85616 8.64384C9.34844 9.13613 9.625 9.80381 9.625 10.5V12.25H4.375V10.5C4.375 9.80381 4.65156 9.13613 5.14384 8.64384C5.63613 8.15156 6.30381 7.875 7 7.875ZM4.375 5.25H6.125V6.5625H4.375V5.25ZM7.875 2.625H9.625V3.9375H7.875V2.625ZM7.875 5.25H9.625V6.5625H7.875V5.25Z"
                            fill="#000842"
                          />
                        </svg>
                      </span>
                      <label className="has-float-label">
                        <input
                          className="form-control py-4 form"
                          type="text"
                          {...register(
                            `companyDetails.${index}.companyName`,
                            addProfessionValidation.companyName
                          )}
                        />
                        <span>
                          Company Name <span className="text-danger">*</span>
                        </span>
                      </label>
                    </div>
                  </div>
                  {errors?.companyDetails?.[index]?.companyName && (
                    <p className="field-error">Company Name is required</p>
                  )}
                </div>
                <div className="col-md-4">
                  <div className="form-group input-group">
                    <div className="form-group input-group">
                      <span className="input-group-addon addon-icon py-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14.1815 9.82345C14.4568 9.84412 14.6628 10.0848 14.6421 10.3601L14.5155 12.0328C14.4108 13.4128 13.2461 14.4935 11.8628 14.4935H4.12947C2.74614 14.4935 1.58147 13.4128 1.47681 12.0328L1.35014 10.3601C1.32947 10.0848 1.53614 9.84412 1.81147 9.82345C2.08814 9.81346 2.32681 10.0088 2.34814 10.2848L2.47414 11.9568C2.53947 12.8181 3.26614 13.4935 4.12947 13.4935H11.8628C12.7261 13.4935 13.4535 12.8181 13.5181 11.9568L13.6448 10.2848C13.6661 10.0088 13.9108 9.81279 14.1815 9.82345ZM8.85627 1.33339C9.85823 1.33339 10.6883 2.08423 10.8133 3.05274L12.1263 3.05332C13.5237 3.05332 14.6597 4.19266 14.6597 5.59399V7.88666C14.6597 8.06466 14.565 8.22866 14.4123 8.31799C12.7668 9.28165 10.6823 9.84373 8.49603 9.91871L8.49627 11.1178C8.49627 11.3938 8.27227 11.6178 7.99627 11.6178C7.72027 11.6178 7.49627 11.3938 7.49627 11.1178L7.49584 9.91887C5.3118 9.84457 3.22711 9.28238 1.58034 8.31799C1.42701 8.22866 1.33301 8.06466 1.33301 7.88666V5.58732C1.33301 4.18999 2.47234 3.05332 3.87301 3.05332L5.17921 3.05274C5.30424 2.08423 6.13432 1.33339 7.13627 1.33339H8.85627ZM12.1263 4.05332H3.87301C3.02367 4.05332 2.33301 4.74132 2.33301 5.58732V7.59532C3.91548 8.45516 5.9105 8.92641 7.987 8.92732L7.99627 8.92646L8.00367 8.92672L8.32111 8.92342C10.285 8.87663 12.1584 8.41069 13.6597 7.59532V5.59399C13.6597 4.74399 12.9723 4.05332 12.1263 4.05332ZM8.85627 2.33339H7.13627C6.68738 2.33339 6.30845 2.6389 6.19651 3.05291H9.79604C9.6841 2.6389 9.30517 2.33339 8.85627 2.33339Z"
                            fill="#000842"
                          />
                        </svg>
                      </span>
                      <label className="has-float-label">
                        <input
                          className="form-control py-4 form"
                          type="text"
                          {...register(
                            `companyDetails.${index}.position`,
                            addProfessionValidation.position
                          )}
                        />
                        <span>
                          Position <span className="text-danger">*</span>
                        </span>
                      </label>
                    </div>
                  </div>
                  {errors?.companyDetails?.[index]?.position && (
                    <p className="field-error">Position is required</p>
                  )}
                </div>
                <div className="col-md-2"></div>
              </div>
              <div className="row ">
                <div className="col-md-2"></div>
                <div className="col-md-4">
                  <div className="form-group input-group">
                    <span className="input-group-addon addon-icon py-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M14.1815 9.82345C14.4568 9.84412 14.6628 10.0848 14.6421 10.3601L14.5155 12.0328C14.4108 13.4128 13.2461 14.4935 11.8628 14.4935H4.12947C2.74614 14.4935 1.58147 13.4128 1.47681 12.0328L1.35014 10.3601C1.32947 10.0848 1.53614 9.84412 1.81147 9.82345C2.08814 9.81346 2.32681 10.0088 2.34814 10.2848L2.47414 11.9568C2.53947 12.8181 3.26614 13.4935 4.12947 13.4935H11.8628C12.7261 13.4935 13.4535 12.8181 13.5181 11.9568L13.6448 10.2848C13.6661 10.0088 13.9108 9.81279 14.1815 9.82345ZM8.85627 1.33339C9.85823 1.33339 10.6883 2.08423 10.8133 3.05274L12.1263 3.05332C13.5237 3.05332 14.6597 4.19266 14.6597 5.59399V7.88666C14.6597 8.06466 14.565 8.22866 14.4123 8.31799C12.7668 9.28165 10.6823 9.84373 8.49603 9.91871L8.49627 11.1178C8.49627 11.3938 8.27227 11.6178 7.99627 11.6178C7.72027 11.6178 7.49627 11.3938 7.49627 11.1178L7.49584 9.91887C5.3118 9.84457 3.22711 9.28238 1.58034 8.31799C1.42701 8.22866 1.33301 8.06466 1.33301 7.88666V5.58732C1.33301 4.18999 2.47234 3.05332 3.87301 3.05332L5.17921 3.05274C5.30424 2.08423 6.13432 1.33339 7.13627 1.33339H8.85627ZM12.1263 4.05332H3.87301C3.02367 4.05332 2.33301 4.74132 2.33301 5.58732V7.59532C3.91548 8.45516 5.9105 8.92641 7.987 8.92732L7.99627 8.92646L8.00367 8.92672L8.32111 8.92342C10.285 8.87663 12.1584 8.41069 13.6597 7.59532V5.59399C13.6597 4.74399 12.9723 4.05332 12.1263 4.05332ZM8.85627 2.33339H7.13627C6.68738 2.33339 6.30845 2.6389 6.19651 3.05291H9.79604C9.6841 2.6389 9.30517 2.33339 8.85627 2.33339Z"
                          fill="#000842"
                        />
                      </svg>
                    </span>
                    <label className="has-float-label">
                      <input
                        className="form-control py-4 form"
                        type="text"
                        {...register(
                          `companyDetails.${index}.workExperience`,
                          addProfessionValidation.workExperience
                        )}
                      />
                      <span>
                        Work Experience <span className="text-danger">*</span>
                      </span>
                    </label>
                  </div>
                  {errors?.companyDetails?.[index]?.workExperience?.message && (
                    <p className="field-error">
                      {errors?.companyDetails?.[index]?.workExperience?.message}
                    </p>
                  )}
                </div>
                <div className="col-md-4 text-right">
                  {index === fields.length - 1 && (
                    <div
                      className="rounded cursor-pointer text-white p-2 add-input mt-1 add-field-btn"
                      title="Add Experience "
                      onClick={() =>
                        append({
                          companyName: "",
                          position: "",
                          workExperience: "",
                        })
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M7.00684 12C7.00684 11.8011 7.08585 11.6103 7.22651 11.4697C7.36716 11.329 7.55792 11.25 7.75684 11.25H11.2498V7.757C11.2498 7.55809 11.3289 7.36733 11.4695 7.22667C11.6102 7.08602 11.8009 7.007 11.9998 7.007C12.1987 7.007 12.3895 7.08602 12.5302 7.22667C12.6708 7.36733 12.7498 7.55809 12.7498 7.757V11.25H16.2428C16.4417 11.25 16.6325 11.329 16.7732 11.4697C16.9138 11.6103 16.9928 11.8011 16.9928 12C16.9928 12.1989 16.9138 12.3897 16.7732 12.5303C16.6325 12.671 16.4417 12.75 16.2428 12.75H12.7498V16.243C12.7498 16.4419 12.6708 16.6327 12.5302 16.7733C12.3895 16.914 12.1987 16.993 11.9998 16.993C11.8009 16.993 11.6102 16.914 11.4695 16.7733C11.3289 16.6327 11.2498 16.4419 11.2498 16.243V12.75H7.75684C7.55792 12.75 7.36716 12.671 7.22651 12.5303C7.08585 12.3897 7.00684 12.1989 7.00684 12Z"
                          fill="white"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.31733 3.769C10.4298 3.42396 13.5709 3.42396 16.6833 3.769C18.5103 3.973 19.9853 5.412 20.1993 7.249C20.5693 10.406 20.5693 13.595 20.1993 16.752C19.9843 18.589 18.5093 20.027 16.6833 20.232C13.5709 20.5771 10.4298 20.5771 7.31733 20.232C5.49033 20.027 4.01533 18.589 3.80133 16.752C3.43211 13.5951 3.43211 10.4059 3.80133 7.249C4.01533 5.412 5.49133 3.973 7.31733 3.769ZM16.5173 5.259C13.5152 4.92623 10.4855 4.92623 7.48333 5.259C6.92757 5.32065 6.40883 5.56787 6.01091 5.96071C5.61299 6.35356 5.35912 6.86908 5.29033 7.424C4.93468 10.465 4.93468 13.537 5.29033 16.578C5.35933 17.1327 5.61329 17.648 6.01119 18.0407C6.4091 18.4333 6.92772 18.6804 7.48333 18.742C10.4603 19.074 13.5403 19.074 16.5173 18.742C17.0728 18.6802 17.5912 18.433 17.9889 18.0404C18.3866 17.6478 18.6404 17.1326 18.7093 16.578C19.065 13.537 19.065 10.465 18.7093 7.424C18.6402 6.86959 18.3863 6.35464 17.9886 5.96222C17.5909 5.5698 17.0726 5.32277 16.5173 5.261V5.259Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  )}
                  {index > 0 && (
                    <span
                      onClick={() => remove(index)}
                      title="Delete Experience "
                      className="rounded cursor-pointer text-white p-2 add-input mt-1 ml-3 delete-field-btn"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 19 20"
                        fill="white"
                      >
                        <path
                          d="M16.0028 6.7332C16.3959 6.7662 16.6885 7.11919 16.6563 7.52219C16.6514 7.58919 16.1218 14.3141 15.8165 17.135C15.6292 18.875 14.5066 19.932 12.8154 19.963C11.5299 19.987 11.2187 20 9.93225 20C9.68841 20 9.44555 20 9.20172 19.999C8.80768 19.997 8.48874 19.669 8.49068 19.264C8.49166 18.861 8.8106 18.536 9.20464 18.536L9.56709 18.5369C10.0237 18.5376 10.3902 18.5363 10.7387 18.5332L11.2569 18.5272C11.6925 18.5211 12.1563 18.5123 12.789 18.501C13.7634 18.482 14.2891 17.983 14.3974 16.975C14.7007 14.1741 15.2294 7.47119 15.2342 7.40419C15.2654 7.00119 15.6146 6.7122 16.0028 6.7332ZM2.01947 6.7329C2.41253 6.7149 2.75683 7.00189 2.78804 7.40489C2.79292 7.47189 3.31765 14.1568 3.62391 16.9797C3.73022 17.9667 4.24911 18.4767 5.16593 18.4967C5.55997 18.5047 5.87306 18.8397 5.86525 19.2437C5.85648 19.6427 5.53851 19.9597 5.1513 19.9597H5.13667C3.51174 19.9247 2.38912 18.8457 2.20478 17.1427C1.89657 14.2968 1.37086 7.58889 1.36599 7.52089C1.3338 7.11889 1.6264 6.7659 2.01947 6.7329ZM11.0795 0C11.967 0 12.7473 0.613991 12.9775 1.49398C13.0799 1.88497 12.8536 2.28597 12.4732 2.39096C12.0938 2.49596 11.7017 2.26397 11.5993 1.87297C11.5359 1.63198 11.3223 1.46398 11.0795 1.46398H6.94301C6.70015 1.46398 6.48655 1.63198 6.42315 1.87297L6.1959 3.04595C6.16468 3.20395 6.11592 3.35195 6.0574 3.49695H17.2973C17.6913 3.49695 18.0112 3.82394 18.0112 4.22794C18.0112 4.63293 17.6913 4.95993 17.2973 4.95993H0.724208C0.330168 4.95993 0.0112305 4.63293 0.0112305 4.22794C0.0112305 3.82394 0.330168 3.49695 0.724208 3.49695H3.91846C4.34371 3.49695 4.71337 3.18595 4.79628 2.75996L5.03426 1.53998C5.27517 0.613991 6.05545 0 6.94301 0H11.0795Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  )}
                </div>
                <div className="col-md-2"></div>
              </div>
            </div>
          );
        })}
        {/* </div> */}
        <div className="row mt-4 mb-5">
          <div className="col-md-2"></div>
          <div className="col-md-4">
            <div className="form-group input-group">
              <span className="input-group-addon addon-icon py-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="15"
                  viewBox="0 0 12 15"
                  fill="none"
                >
                  <path
                    d="M6.25 5.25V5.75H6.75H10.875H11.5V13.5C11.5 13.7652 11.3946 14.0196 11.2071 14.2071C11.0196 14.3946 10.7652 14.5 10.5 14.5H1.5C1.23478 14.5 0.98043 14.3946 0.792894 14.2071L0.43934 14.5607L0.792893 14.2071C0.605357 14.0196 0.5 13.7652 0.5 13.5V1.5C0.5 0.943642 0.943642 0.5 1.5 0.5H6.25V1.125V5.25ZM11.5 5.16789L11.2286 4.89645L7.10355 0.771447L6.83211 0.5H7.29289L11.5 4.70711V5.16789ZM7.5 14H8V13.5V12.75C8 12.3166 7.77855 11.9743 7.51037 11.7271C7.24554 11.4831 6.90297 11.2991 6.55988 11.1617C6.16495 11.0037 5.72758 10.891 5.32041 10.824C5.53948 10.7255 5.74108 10.5873 5.91421 10.4142C6.28929 10.0391 6.5 9.53043 6.5 9C6.5 8.46957 6.28929 7.96086 5.91421 7.58579C5.53914 7.21071 5.03043 7 4.5 7C3.96957 7 3.46086 7.21071 3.08579 7.58579C2.71071 7.96086 2.5 8.46957 2.5 9C2.5 9.53043 2.71071 10.0391 3.08579 10.4142C3.25892 10.5873 3.46052 10.7255 3.67959 10.824C3.27242 10.891 2.83505 11.0037 2.44012 11.1617C2.09703 11.2991 1.75446 11.4831 1.48963 11.7271C1.22145 11.9743 1 12.3166 1 12.75V13.5V14H1.5H7.5Z"
                    stroke="#000842"
                  />
                </svg>
              </span>
              <label className="has-float-label">
                {/* <input
                  className="form-control py-4 form"
                  type="text"
                  {...register("interest")}
                /> */}
                <Controller
                  control={control}
                  name="interest"
                  rules={{
                    required: { value: true, message: "Interest is required" },
                  }}
                  render={({ field: { value, onChange } }) => (
                    <MultiSelect
                      options={interest}
                      hidePlaceholder={true}
                      closeOnSelect={false}
                      onSelect={onChange}
                      onRemove={onChange}
                      selectedValues={value}
                      isObject={false}
                      // displayValue="name"
                      onSearch={(interest) => {
                        setInterestValue(interest);
                      }}
                      className="multi-select-wrapper"
                    />
                  )}
                />
                <span>
                  Interest <span className="text-danger">*</span>
                </span>
              </label>
            </div>
            {errors.interest && (
              <p className="field-error">Interest is required</p>
            )}
          </div>
          <div className="col-md-4">
            <div className="form-group input-group">
              <span className="input-group-addon addon-icon py-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                >
                  <g clipPath="url(#clip0_78_761)">
                    <path
                      d="M8.51392 10.7898L9.6071 11.6678L9.31611 10.2962L8.6632 7.21886L10.6144 5.22468L11.367 4.45546L10.2938 4.37635L7.87703 4.19823L6.97732 1.31362L6.72355 0.5H11.7C12.0405 0.5 12.5 0.89751 12.5 1.625V4.45488C11.6982 4.72123 11.2 5.61236 11.2 6.5C11.2 7.38764 11.6982 8.27877 12.5 8.54512V11.375C12.5 12.1025 12.0405 12.5 11.7 12.5H1.3C0.959492 12.5 0.5 12.1025 0.5 11.375V8.5459C1.30621 8.28029 1.8 7.38716 1.8 6.5C1.8 5.61512 1.3081 4.72181 0.5065 4.45495V1.625C0.5065 0.893993 0.962295 0.5 1.3 0.5H6.27874L6.02306 1.3124L5.11741 4.19004L2.69975 4.36823L1.62648 4.44733L2.37911 5.21655L4.33083 7.21128L3.68364 10.2974L3.39695 11.6645L4.48608 10.7898L6.5 9.17252L8.51392 10.7898Z"
                      stroke="#000842"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_78_761">
                      <rect width="13" height="13" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <label className="has-float-label">
                <Controller
                  control={control}
                  name="skills"
                  rules={{
                    required: { value: true, message: "Skills is required" },
                  }}
                  render={({ field: { value, onChange } }) => (
                    <MultiSelect
                      isObject={false}
                      options={skills}
                      hidePlaceholder={true}
                      closeOnSelect={false}
                      onSelect={onChange}
                      onRemove={onChange}
                      selectedValues={value}
                      // displayValue="name"
                      onSearch={(skillValue) => {
                        setSkillValue(skillValue);
                      }}
                      className="multi-select-wrapper"
                    />
                  )}
                ></Controller>
                <span>
                  Skills <span className="text-danger">*</span>
                </span>
              </label>
            </div>
            {errors.skills && <p className="field-error">Skills is required</p>}
          </div>
          <div className="col-md-2"></div>
        </div>
        <div className="row mt-4 mb-5">
          <div className="col-md-2"></div>
          <div className="col-md-4">
            <div className="form-group input-group">
              <span className="input-group-addon addon-icon py-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                >
                  <g clipPath="url(#clip0_78_761)">
                    <path
                      d="M8.51392 10.7898L9.6071 11.6678L9.31611 10.2962L8.6632 7.21886L10.6144 5.22468L11.367 4.45546L10.2938 4.37635L7.87703 4.19823L6.97732 1.31362L6.72355 0.5H11.7C12.0405 0.5 12.5 0.89751 12.5 1.625V4.45488C11.6982 4.72123 11.2 5.61236 11.2 6.5C11.2 7.38764 11.6982 8.27877 12.5 8.54512V11.375C12.5 12.1025 12.0405 12.5 11.7 12.5H1.3C0.959492 12.5 0.5 12.1025 0.5 11.375V8.5459C1.30621 8.28029 1.8 7.38716 1.8 6.5C1.8 5.61512 1.3081 4.72181 0.5065 4.45495V1.625C0.5065 0.893993 0.962295 0.5 1.3 0.5H6.27874L6.02306 1.3124L5.11741 4.19004L2.69975 4.36823L1.62648 4.44733L2.37911 5.21655L4.33083 7.21128L3.68364 10.2974L3.39695 11.6645L4.48608 10.7898L6.5 9.17252L8.51392 10.7898Z"
                      stroke="#000842"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_78_761">
                      <rect width="13" height="13" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <label className="has-float-label">
                <Controller
                  control={control}
                  name="skillsCategory"
                  rules={{
                    required: {
                      value: true,
                      message: "Categories is required",
                    },
                  }}
                  render={({ field: { value, onChange } }) => (
                    <MultiSelect
                      // isObject={false}
                      options={categories}
                      hidePlaceholder={true}
                      closeOnSelect={false}
                      onSelect={(selectedList) =>
                        handleChange(selectedList, onChange)
                      }
                      onRemove={(selectedList) =>
                        handleChange(selectedList, onChange)
                      }
                      selectedValues={categories.filter((category) =>
                        value.includes(category._id)
                      )}
                      displayValue="name"
                      className="multi-select-wrapper"
                    />
                  )}
                ></Controller>
                <span>
                  Categories <span className="text-danger">*</span>
                </span>
              </label>
            </div>
            {errors.skillCategories && (
              <p className="field-error">Categories is required</p>
            )}
          </div>
          <div className="col-md-2"></div>
        </div>
        <div className="row mt-4">
          <div className="col-md-2"></div>
          <div className="col-md-8">
            <div className="form-group ">
              <label className="switch-label">
                <span>You want to offer Service?</span>
              </label>
              <label class="switch">
                <input
                  type="checkbox"
                  checked={offerService}
                  onChange={handleOfferServiceChange}
                  {...register("offerService")}
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
        {offerService && (
          <div className="row mt-4">
            <div className="col-md-2"></div>
            <div className="col-md-8">
              <div className="form-group input-group">
                <span className="input-group-addon addon-icon py-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_673_1468)">
                      <path
                        d="M8.51392 10.7898L9.6071 11.6678L9.31611 10.2962L8.6632 7.21886L10.6144 5.22468L11.367 4.45546L10.2938 4.37635L7.87703 4.19823L6.97732 1.31362L6.72355 0.5H11.7C12.0405 0.5 12.5 0.89751 12.5 1.625V4.45488C11.6982 4.72123 11.2 5.61236 11.2 6.5C11.2 7.38764 11.6982 8.27877 12.5 8.54512V11.375C12.5 12.1025 12.0405 12.5 11.7 12.5H1.3C0.959492 12.5 0.5 12.1025 0.5 11.375V8.5459C1.30621 8.28029 1.8 7.38716 1.8 6.5C1.8 5.61512 1.3081 4.72181 0.5065 4.45495V1.625C0.5065 0.893993 0.962295 0.5 1.3 0.5H6.27874L6.02306 1.3124L5.11741 4.19004L2.69975 4.36823L1.62648 4.44733L2.37911 5.21655L4.33083 7.21128L3.68364 10.2974L3.39695 11.6645L4.48608 10.7898L6.5 9.17252L8.51392 10.7898Z"
                        stroke="#000842"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_673_1468">
                        <rect width="13" height="13" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <label className="has-float-label">
                  <Controller
                    control={control}
                    name="experties"
                    rules={{
                      required: {
                        value: offerService,
                        message: "Experties is required",
                      },
                    }}
                    render={({ field: { value, onChange } }) => (
                      <MultiSelect
                        options={expertises}
                        hidePlaceholder={true}
                        closeOnSelect={false}
                        onSelect={onChange}
                        onRemove={onChange}
                        selectedValues={value}
                        isObject={false}
                        // displayValue="name"
                        onSearch={(expertise) => {
                          setExpertiseValue(expertise);
                        }}
                        className="multi-select-wrapper"
                      />
                    )}
                  />
                  <span>
                    {/* SME (Subject matter expertise refers to the specific area or
                  topic in which an individual can mentor){" "} */}
                    Subject matter expertise (SME)
                    {offerService && <span className="text-danger">*</span>}
                  </span>
                </label>
              </div>
              {offerService && errors.experties && (
                <p className="field-error">Expertise is required</p>
              )}
            </div>
            <div className="col-md-2"></div>
          </div>
        )}

        <div className="row mb-4">
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <div className="justify-content-center">
              <button
                type="submit"
                className="btn btn-primary btn-block sign-btn  mt-5"
              >
                Submit
              </button>
            </div>
          </div>
          <div className="col-md-4"></div>
        </div>
      </form>
    </>
  );
};

export default AddProfessionInfo;
